import { LeftOutlined, PrinterOutlined } from '@ant-design/icons'
import { Button, Card, Flex, Space } from 'antd'
import { FormInstance } from 'antd/lib'
import { useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'

import {
  InquiryDocumentResponse,
  InventoryDocumentState,
  IssuanceDocumentResponse
} from 'src/api/requests'
import { IssuanceBody, IssuanceHeader } from 'src/features/stock/components'
import { AdminConsumableList } from 'src/features/stock-administration/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

type Props = {
  data?: IssuanceDocumentResponse
  inquireData?: InquiryDocumentResponse
  form: FormInstance
}

export const StockIssuanceAcceptedDetails = ({
  data,
  inquireData,
  form
}: Props) => {
  const { t } = useLocales()
  const navigate = useNavigate()

  const { id } = useParams()

  const printableRef = useRef<HTMLDivElement>(null)

  const onPrint = useReactToPrint({
    contentRef: printableRef,
    documentTitle: `Stock_Issuance_${id}`
  })

  const onBackClick = () => {
    navigate(paths.issuance.root)
  }

  return (
    <Flex vertical gap={24}>
      <Flex justify="space-between">
        <Button
          icon={<LeftOutlined />}
          className="fit-content"
          onClick={onBackClick}
          disabled={false}
        >
          {t('common.back')}
        </Button>

        <Space size={8}>
          <Button
            icon={<PrinterOutlined />}
            disabled={false}
            onClick={() => onPrint()}
          >
            {t('stock_applications.print')}
          </Button>
        </Space>
      </Flex>

      <Flex vertical gap={16} ref={printableRef}>
        <IssuanceHeader data={data} inquireData={inquireData} />

        <Card>
          <Flex vertical gap={16}>
            <AdminConsumableList
              isEdit={data?.state !== InventoryDocumentState.REJECTED}
              data={inquireData}
              issuanceData={data}
              form={form}
              isSubmitted={true}
            />

            <IssuanceBody data={data} />
          </Flex>
        </Card>
      </Flex>
    </Flex>
  )
}
